import styled from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';
import DraggableCard from '../DraggableCard';

export const NOTES_CARDS_WIDTH_PX = 560;

export const StyledDraggableCard = styled(DraggableCard)`
  width: 100%;
  height: 100%;
`;

export const NotesCardHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.mlg};
  line-height: ${({ theme }: ThemeProp) => theme.lineHeight.mlg};
  font-weight: ${({ theme }: ThemeProp) => theme.fontWeight.medium};
  color: ${({ theme }: ThemeProp) => theme.colors.greyscale.c050};
`;
